import React, { useEffect, useState } from 'react';
import './ProfileBanner.css';
import PlayButton from '../components/PlayButton';
import MoreInfoButton from '../components/MoreInfoButton';
import { getProfileBanner } from '../queries/getProfileBanner';
import { ProfileBanner as ProfileBannerType } from '../types';

const RESUME_URL = "https://drive.google.com/file/d/10KIRsUphkuFa1eHGLVVxM9dCj_SlsCrk/view?usp=sharing";

// Fallback data in case API request fails
const FALLBACK_BANNER_DATA: ProfileBannerType = {
  backgroundImage: { url: "https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif" },
  headline: "Vinayak Singh",
  resumeLink: {
    url: RESUME_URL
  },
  linkedinLink: "https://www.linkedin.com/in/vinayak-singh-147047238/",
  profileSummary: "AI & Full Stack Innovator | Building Products that Think, Learn & Scale\nI design and deploy intelligent web systems — blending AI, automation, and full-stack development to turn bold ideas into reality."
};

const ProfileBanner: React.FC = () => {
  const [bannerData, setBannerData] = useState<ProfileBannerType | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getProfileBanner();
        setBannerData(data);
      } catch (err) {
        console.error("Failed to fetch banner data:", err);
        setError("Failed to load profile data. Showing fallback content.");
        // Use fallback data when API request fails
        setBannerData(FALLBACK_BANNER_DATA);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  if (loading) return <div className="banner-loading">Loading profile...</div>;

  if (error) {
    console.warn(error);
  }

  // If we still don't have data for some reason, use fallback
  const displayData = bannerData || FALLBACK_BANNER_DATA;

  const handlePlayClick = () => {
    window.open(RESUME_URL, '_blank');
  };

  const handleLinkedinClick = () => {
    window.open(displayData.linkedinLink, '_blank');
  }

  return (
    <div className="profile-banner">
      <div className="banner-content">
        <h1 className="banner-headline" id='headline'>{displayData.headline}</h1>
        <p className="banner-description">
          {displayData.profileSummary.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>

        <div className="banner-buttons">
          <PlayButton onClick={handlePlayClick} label="Resume" />
          <MoreInfoButton onClick={handleLinkedinClick} label="LinkedIn" />
        </div>
      </div>
    </div>
  );
};

export default ProfileBanner;